import React from "react";
import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  Link,
} from "@chakra-ui/react";

import Footer from "../components/footer";
import Customerservicebot from "./customerservicesbot";

export default function TermsofService() {
  return (
    <>
      <Customerservicebot />
      <Box>
        <Container maxW="full" mt={0} centerContent overflow="hidden">
          <Flex>
            <Box maxW="1500px" mx="auto" px={4} mt={10} style={{marginLeft:"20px",marginRight:"20px"}}>
              <Heading as="h3" style={{ margin: "20px", textAlign: "center", color: "#3A56D4" }}>
                Terms of Service
              </Heading>

              <Text style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                These terms and conditions outline the rules and regulations for the use
                of Unlimiteye Solutions Pvt. Ltd. Website, located{" "}
                <Link href="https://www.unlimiteye.com" color="#3A56D4">
                  https://www.unlimiteye.com
                </Link>{" "}
                and{" "}
                <Link href="https://www.aptofy.com" color="#3A56D4">
                  https://www.aptofy.com
                </Link>
                . By accessing this website, we assume you accept these terms and conditions.
                Do not continue to use Unlimiteye Solutions products and services if you do
                not agree to take all of the terms and conditions stated on this page.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                The following terminology applies to these Terms and Conditions,
                Privacy Statement, and Disclaimer Notice and all Agreements: "Client",
                "You," and "Your" refer to you, the person log on this website and
                compliant to the Company’s terms and conditions. "The Company",
                "Ourselves," "We," "Our," and "Us" refer to our Company. "Party",
                "Parties," or "Us" refer to both the Client and ourselves. All terms refer
                to the offer, acceptance, and consideration of payment necessary to
                undertake the process of our assistance to the Client in the most
                appropriate manner for the express purpose of meeting the Client’s
                needs in respect of the provision of the Company’s stated services, in
                accordance with and subject to the prevailing law of India. Any use of the
                above terminology or other words in the singular, plural, capitalization,
                and/or he/she or they are taken as interchangeable and therefore as
                referring to the same.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>1. Acceptance of Terms</strong>
                <br />
                By using our services, you acknowledge that you have read,
                understood, and agree to be bound by these terms. If you do not
                agree to these terms, please refrain from using our platform.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>2. Data Privacy and Consent</strong>
                <br />
                <b style={{marginLeft:"10px"}}>a. Data Collection:</b> We collect personal information from users in
                accordance with our Privacy Policy. By using our services, you
                consent to the collection, use, and disclosure of your personal
                information as outlined in our Privacy Policy.
                <br />
                <b style={{marginLeft:"10px"}}>b. Data Storage:</b> We will store personal information securely and
                take appropriate measures to protect it. Users have the right to
                request access, correction, or deletion of their personal
                information.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>3. Cookies</strong>
                <br />
                We do not use cookies on our platform. You can refer to our
                separate Cookie Policy for more details.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>4. Job Postings Responsibility</strong>
                <br />
                <b style={{marginLeft:"10px"}}>a. Authorized Recruiters:</b> Job postings by recruiters other than
                Unlimiteye or Aptofy are not the responsibility of Unlimiteye. We
                take suitable measures to curb malpractice but cannot
                guarantee the authenticity of all job postings.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>5. Fraudulent Actions</strong>
                <br />
                Any fraudulent actions, including but not limited to, false job
                postings, misrepresentation, or unauthorized use of our platform,
                are strictly prohibited. We reserve the right to take legal action
                against those involved in such activities.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>6. AI Analysis and Decision Making</strong>
                <br />
                <b style={{marginLeft:"10px"}}>a. Candidate Reports:</b>Reports generated through AI analysis,
                scorecards, proctoring results, and other assessments are for
                informational purposes. We retain the right to make decisions
                based on these results.
                <br />
                <b style={{marginLeft:"10px"}}>b. Decision Authority:</b> Unlimiteye Solutions Pvt. Ltd. reserves the
                right to make final decisions regarding candidate suitability,
                matching, and placement based on the assessments
                conducted. Assessment results are auto-generated with 98%
                accuracy.
                <br />
                <b style={{marginLeft:"10px"}}>c. Candidate ID Validation:</b> Unlimiteye Solutions Pvt. Ltd. reserves
                the right to make final decisions regarding candidate ID validation
                and Candidate Authentication. Authentications are at 99%
                accuracy.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>7. Modification of Terms</strong>
                <br />
                Unlimiteye Solutions pvt. Ltd. reserves the right to modify these
                terms at any time. Users will be notified of any changes, and
                continued use of our services after such modifications constitutes
                acceptance of the updated terms.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>8. Governing Law</strong>
                <br />
                These terms are governed by and construed in accordance with
                the laws of India. Any disputes arising from these terms or the use
                of our services will be subject to the exclusive jurisdiction of the
                courts in our Headquarter, Bengaluru, India.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                If you have any questions or concerns regarding these terms,
                please contact us at aptofycare@unlimiteye.com
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                Thank you for choosing Unlimiteye Solutions Pvt. Ltd. for your
                digital Transformation needs.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>LICENSE</strong>
                <br />
                <br/>
                Unless otherwise stated, Unlimiteye Solutions Pvt. Ltd. and/or its
                licensors own the intellectual property rights for all material on its’
                websites. All intellectual property rights are reserved. You may
                access this from Unlimiteye Solutions pvt. ltd. for your own personal
                use subjected to restrictions set in these terms and conditions.
                <br />
                You must not,
                <ul style={{marginLeft:"20px"}}>
                  <li>Republish material from Unlimiteye Solutions Pvt. Ltd.</li>
                  <li>Sell, rent, or sub-license material from Unlimiteye Solutions Pvt. Ltd.</li>
                  <li>Reproduce, duplicate, or copy material,</li>
                  <li>Redistribute content from Unlimiteye Solutions Pvt. Ltd.</li>
                </ul>
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>Hyperlinking Policy Summary:</strong>
                <br />
                Unlimiteye Solutions Pvt. Ltd. allows the following organizations to
                link to its website without prior written approval:
                <ul>
                  <b>a.Permitted Organizations:</b>
                  <ul typeof="none">
                    <li style={{marginLeft:"25px"}}>Government agencies</li>
                    <li style={{marginLeft:"25px"}}>Search engines</li>
                    <li style={{marginLeft:"25px"}}>News organizations</li>
                  </ul>
                </ul>
                <br />
                <strong>Linking Conditions:</strong>
                <br />
                Links should not be deceptive or falsely imply sponsorship,
                endorsement, or approval.
                Links must fit within the context of the linking party's site.
                <br />
                <strong>Additional Link Approvals:</strong>
                <br />
                Unlimiteye Solutions Pvt. Ltd. may consider link requests from other
                types of organizations, including consumer/business information
                sources, dot.com community sites, charities, online directories,
                internet portals, and educational institutions.
                <br />
                <strong>Approval Criteria:</strong>
                <br />
                Approval is subject to criteria such as the link not reflecting
                negatively on Unlimiteye Solutions Pvt. Ltd., no negative records
                with the organization, and the benefit of visibility compensating for
                the absence of reciprocal linking.
                <br />
                <strong>Link Request Process:</strong>
                <br />
                Interested organizations must inform Unlimiteye Solutions pvt.
                Ltd. via email, providing organization and contact details, site URLs,
                and intended link URLs. Wait for a response prior to usage.
                <br />
                <strong>Restrictions on Logo/Artwork Use:</strong>
                <br />
                No use of Unlimiteye Solutions Pvt. Ltd. logos' or artwork is
                allowed for linking without a trademark license agreement.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>iFrames</strong>
                <br />
                Without prior approval and written permission, you may not create
                frames around our Webpages that alter in any way the visual
                presentation or appearance of our Website.
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                This Agreement shall begin on the date hereof
              </Text>

              <Text  style={{fontSize:"16px",marginLeft:"10px",marginRight:"10px"}}>
                <strong>YOUR PRIVACY</strong>
                <br />
                Please read Privacy Policy.
                <br/>
                <br/>
              </Text>
            </Box>
          </Flex>
        </Container>
        <Footer />
      </Box>
    </>
  );
}
